import { Injectable } from '@angular/core';
import {
    FacebookPixelsConfig,
    GetConfigResponse,
    GetConfigPayload,
} from '@app/_models/integrations/facebook_pixels.model';
import { ApiService } from '@app/_services/api.service';
import { CommomHeaders } from '@app/_shared/httpHeaders/CommonHeaders';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FacebookPixelsService {
    constructor(private api: ApiService, private headers: CommomHeaders) {}

    setConfig(payload: FacebookPixelsConfig) {
        return this.api.postFz(`/api/v1/back/config`, payload, this.headers.getAuthHeaders());
    }

    getConfig(payload: GetConfigPayload): Observable<GetConfigResponse> {
        return this.api.get<GetConfigResponse>(`/api/v1/back/config/get`, payload, this.headers.getAuthHeaders());
    }
}
